export default "__VITE_ASSET__B736JIrZ__"